// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangeVersionDialog_content__3sedGRa9RqG1AhtBXuEJOX","buttons":"ChangeVersionDialog_buttons__2VJHjtAgTMl8CxvslB0gnU"};